import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { CustomerOrder, CustomOrderSearchCommand } from '../../models/order/CustomerOrder';
import { ShipmentSegment } from '../../models/shipment-segment/shipment-segment';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class CustomerOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/customer-order';

  public createCustomerOrder(data: CustomerOrder): Observable<ApiResponse<CustomerOrder>> {
    return this.httpClient.post<ApiResponse<CustomerOrder>>(this.baseUrl, data);
  }

  public updateCustomerOrder(id: string, data: CustomerOrder): Observable<ApiResponse<CustomerOrder>> {
    return this.httpClient.put<ApiResponse<CustomerOrder>>(this.baseUrl + '/' + id, data);
  }

  public getCustomerOrders(): Observable<ApiResponse<CustomerOrder>> {
    return this.httpClient.get<ApiResponse<CustomerOrder>>(this.baseUrl + '/all');
  }

  public getCustomerOrderById(id: string, materialize = false): Observable<ApiResponse<CustomerOrder>> {
    return this.httpClient.get<ApiResponse<CustomerOrder>>(this.baseUrl + '/' + id + '?materialize=' + materialize);
  }

  public searchCustomerOrder(command: CustomOrderSearchCommand): Observable<ApiResponse<CustomerOrder[]>> {
    return this.httpClient.post<ApiResponse<CustomerOrder[]>>(this.baseUrl + '/search', command);
  }

  public getCustomerOrdersShipmentSegmentsId(id: string): Observable<ApiResponse<ShipmentSegment>> {
    return this.httpClient.get<ApiResponse<ShipmentSegment>>(this.baseUrl + '/' + id + '/shipment-segment');
  }
}
